// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1fm93","filesListContainer":"PosDisputesFiles_filesListContainer__2OskG","filesButton":"PosDisputesFiles_filesButton__27UKm"};